import { render, staticRenderFns } from "./add-drawlots-pop.vue?vue&type=template&id=0f3cf61a&scoped=true&"
import script from "./add-drawlots-pop.vue?vue&type=script&lang=js&"
export * from "./add-drawlots-pop.vue?vue&type=script&lang=js&"
import style0 from "./add-drawlots-pop.vue?vue&type=style&index=0&id=0f3cf61a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3cf61a",
  null
  
)

export default component.exports